import React from 'react';
import SelectAsyncComponent from '../../../componentes/select/select-async.component';
import { Row, Col, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import DateInput from '../../../componentes/datepicker/react-datepicker.component';
import SelectComponent from '@componentes/select/select.component';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import IntlMessage from "../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

const CitologiaModalPage = (props) => {
    const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
    return(
    <Modal isOpen={props.open} toggle={props.toggle} size="lg">
        <div className="citologia-modal-page">
            <ModalHeader toggle={props.toggle}><IntlMessage id = "dashboards.cytology.addBlades"/></ModalHeader>
            <ModalBody>
                <Row>
                    <Col sm={2}>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.cytology.numberExam"/></Label>
                            <Input
                                id="laudo"
                                className={props.laudoNaoExiste && props.laudo.length === 8 ? 'laudo-inexistente' : undefined}
                                type="text"
                                value={props.nr_exame}
                                innerRef={props.laudoRef}
                                disabled={!props.laudoNaoExiste}
                                onChange={(ev) => props.alterarValorState('nr_exame', ev.currentTarget.value)}
                                onKeyPress={(ev) => {
                                    ev.key === 'Enter' && props.pesquisaNumExame(ev.currentTarget.value)
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={4}>
                        <FormGroup>
                            <Label><IntlMessage id='dashboards.examDetail.patient' /></Label>
                            <Input
                                disabled={true}
                                className="fz-13"
                                value={props.paciente}/>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.cytology.blockCytology"/></Label>
                            <SelectComponent
                                options={props.blocosCitologia}
                                onChange={(el) => props.alterarValorState('blocoCitologia', el)}
                                value={props.blocoCitologia}
                                placeholder={translate("dashboards.cytology.selectBlock")}
                                noOptionsMessage={() => <IntlMessage id = "dashboards.cytology.noBlock"/>}
                                disabled={props.laudoNaoExiste}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.examDetail.bladeAddOn"/></Label>
                           <SelectCreatableComponent
                                onChange={(ev) => props.alterarValorState('complememtoLamina', ev)}
                                onCreateOption={props.handleCreateSelectCreatable}
                                options={props.complementos}
                                placeholder={translate("dashboards.examDetail.selectBladeAddOn")}
                                label={<IntlMessage id = "dashboards.examDetail.registerNewAddOn"/>}
                                value={props.complememtoLamina}
                                disabled={props.laudoNaoExiste}
                            />
                        </FormGroup>
                    </Col>
                    <Col className="w-130">
                        <FormGroup>
                            <Label className="label-centralizado"><IntlMessage id = "dashboards.examDetail.qtyBlades"/></Label>
                            <div className="qtd-laminas-group">
                                <button
                                    disabled={props.laudoNaoExiste}
                                    className="qtd-laminas-button float-left"
                                    onClick={() => props.alterarValorState('qtdLaminas', props.qtdLaminas - 1)}
                                >
                                    <i className="fas fa-minus"></i>
                                </button>
                                <Input
                                    style={{ width: '40px' }}
                                    type="number"
                                    value={props.qtdLaminas}
                                    disabled={props.laudoNaoExiste}
                                    onChange={(ev) => props.alterarValorState('qtdLaminas', ev.currentTarget.value)}
                                />
                                <button
                                    disabled={props.laudoNaoExiste}
                                    className="qtd-laminas-button float-left"
                                    onClick={() => props.alterarValorState('qtdLaminas', props.qtdLaminas + 1)}
                                >
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.examDetail.annotations"/></Label>
                            <Input type="textarea" maxLength={300} disabled={props.laudoNaoExiste} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.examDetail.unconformities"/></Label>
                            <SelectComponent
                                options={props.naoconformidades}
                                onChange={(ev) => props.alterarValorState('nConfInclusaoLamina', ev)}
                                value={props.nConfInclusaoLamina}
                                disabled={props.laudoNaoExiste}
                                placeholder={translate("dashboards.examDetail.selectUnconformities")}/>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.examDetail.date"/></Label>
                            <DateInput
                                className='filtro-data'
                                value={props.dataInclusaoLamina}
                                readOnly={true}
                                disabled={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.cytology.technician"/></Label>
                            <SelectAsyncComponent
                                options={props.tecnicos}
                                value={props.tecnico}
                                placeholder={translate("dashboards.examDetail.selectTechnician")}
                                disabled={props.laudoNaoExiste}
                                onChange={(ev) => { props.alterarValorState('tecnico', ev) }}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.cytology.pathologist"/></Label>
                            <SelectAsyncComponent
                                options={props.patologistas}
                                value={props.patologista}
                                placeholder={translate("dashboards.examDetail.selectPathologist")}
                                disabled={props.laudoNaoExiste}
                                onChange={(ev) => { props.alterarValorState('patologista', ev) }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className='paddingTop-none'>
                {
                    !props.laudoNaoExiste && <Button
                        color="danger"
                        onClick={props.limparCamposAdicionarLaminas}
                    >
                        <IntlMessage id = "dashboards.examDetail.clearFields"/>
                    </Button>
                }
                <Button color="secondary" onClick={props.toggle}>
                    <IntlMessage id = "dashboards.examDetails.cancel"/>
                </Button>
                <Button
                    color="primary"
                    onClick={props.adicionarLamina}
                    disabled={!(
                        props.qtdLaminas > 0 &&
                        props.laudo !== '' &&
                        props.tecnico !== null &&
                        !props.laudoNaoExiste &&
                        !props.laudo.length < 8
                    )}
                >
                    <IntlMessage id = "dashboards.examDetail.addBlade"/>
                </Button>
            </ModalFooter>
        </div>
    </Modal>

)
                    }
export default CitologiaModalPage;


// WEBPACK FOOTER //
// ./src/pages/citologia/content/citologia.modal.page.js